/* eslint-disable no-unused-vars */
import {
  ModalButtonWrapper,
  ModalGap,
  StyledContainer,
} from '../../../services/settings/appStyle/global.style';
import { IntlMessages } from '../../../helper/langHelper';
import {
  BroadcastContainer,
  BroadcastContainerLeft,
  BroadcastContainerRight,
  BroadcastHeaderContainer,
  InputWrapper,
  LabelTitle,
  HeaderTitle,
  EmergencyButton,
  GroupRow,
  GroupHeaderRow,
  ViewIconButton,
  GroupMemberPanel,
  MemberRow,
  MemberAvatar,
  MemberInfo,
  MemberEmail,
} from './broadCast.style';
import {
  Button,
  InputField,
  Label,
  TabButton,
  TextAreaField,
} from '../../../Components/uielements';
import { CheckBoxContainer } from '../UserV2/user.style';
import CheckBoxField from '../../../Components/form-fields/checkBox';
import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useUserContext } from '../../../hooks/UserContext';
import GeofenceService from '../../../services/bioplus-services/geofence';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import { useCompany } from '../../../hooks/CompanyContext';
import { BroadCastInfoModal } from './modals';
import {
  broadcastALert,
  notifyFriends,
} from '../../../services/bioplus-services/broadcast-services';
import DropDown from '../../../Components/uielements/dropDown';
import {
  PaginationButton,
  PaginationLeft,
  PaginationRight,
  PaginationTitle,
} from '../../app/navbar/navbar.style';
import { RightArrowPrimary, RightArrowDisabled, EyeIcon } from '../../../Components/icons';
import { allowedFileTypes } from '../../../services/constant/constant';
import moment from 'moment';
import FileUploader from '../../../Components/uielements/fileUploader';
import { getAllowedFileExtensions } from '../../../helper/validationHelper';
import { friendList } from '../../../services/bioplus-services/friendList';
import { listGroupMembers } from '../../../services/bioplus-services/group';
import GroupIcon from '@mui/icons-material/Group';
import GroupsIcon from '@mui/icons-material/Groups';

const PartnerBroadcast = () => {
  const [selectedGeofences, setSelectedGeofences] = useState([]);
  const [selectedFriends, setSelectedFriends] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedBusinessGroups, setSelectedBusinessGroups] = useState([]);
  const [notifyTab, setNotifyTab] = useState('friends'); // 'friends' | 'groups' | 'business groups'
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [name, setName] = useState();
  const [isSuccessAndFailBroadcast, setIsSuccessAndFailBroadcast] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [message, setMessage] = useState('');
  const [alertType, setAlertType] = useState('BROADCAST');
  const [isMessageEmpty, setIsMessageEmpty] = useState(false);
  const [selectedFileType, setSelectedFileType] = useState(allowedFileTypes[0].value);
  const [error, setError] = useState(null);
  const [expandedGroup, setExpandedGroup] = useState(null);
  const [expandedBusinessGroup, setExpandedBusinessGroup] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [title, setTitle] = useState('');

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setFileName(event.target.files[0].name);
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result.split(',')[1];
        setSelectedFile(base64String);
      };

      reader.onerror = () => {
        setError('Failed to process the file. Please try again.');
      };

      reader.readAsDataURL(file);
    }
  };

  const handleChange = (e) => {
    const newMessage = e.target.value;
    setMessage(newMessage);
    setIsMessageEmpty(newMessage.trim() === '');
  };

  const userContext = useUserContext();
  const companyContext = useCompany();
  const companyFilter = companyContext?.company?._id;
  const partnerId = userContext?.company?.partnerId;

  const geofenceQuery = useQuery(
    ['partnerGeofences', partnerId, companyFilter, name, page, pageSize],
    () =>
      GeofenceService.listByPartner(
        partnerId,
        { companyId: companyFilter, name, occupants: true },
        page,
        pageSize
      ),
    {
      enabled: alertType !== 'NOTIFY',
    }
  );

  const geofencesData = geofenceQuery?.data?.data ?? [];

  const companyId = userContext?.company?.companyId?._id;
  const businessGroupCompanyId = companyFilter ?? userContext?.company?.companyId?._id;
  const groupType = 'FRIEND';
  const businessGroupType = 'BUSINESS';
  const userType =
    userContext?.company?.role === 'EMPLOYEE' ? 'OWNER' : userContext?.company?.role || 'ADMIN';
  const businessGroupUserType = companyFilter
    ? 'OWNER'
    : userContext?.company?.role === 'EMPLOYEE'
    ? 'OWNER'
    : userContext?.company?.role || 'ADMIN';

  // Friends query for NOTIFY
  const friendsQuery = useQuery(['friendList'], () => friendList(), {
    enabled: alertType === 'NOTIFY',
  });
  const friends = friendsQuery?.data ?? [];

  // Groups query for NOTIFY
  const groupsQuery = useQuery(
    ['listGroupMembers', groupType],
    () => listGroupMembers({ companyId, groupType, userType }),
    {
      enabled: alertType === 'NOTIFY',
    }
  );
  const groupListData = groupsQuery?.data ?? [];

  // Business Groups query for NOTIFY
  const businessGroupsQuery = useQuery(
    ['listGroupMembers', businessGroupType, businessGroupUserType, businessGroupCompanyId],
    () =>
      listGroupMembers({
        companyId: businessGroupCompanyId,
        groupType: businessGroupType,
        userType: businessGroupUserType,
      }),
    {
      enabled: alertType === 'NOTIFY',
    }
  );
  const businessGroupListData = businessGroupsQuery?.data ?? [];

  // pagination
  const total = geofenceQuery?.data?.total ?? 0;
  const start = page * pageSize + 1;
  const end = Math.min((page + 1) * pageSize, total);
  const maxPages = Math.ceil(total / pageSize);
  const hasPrev = page > 0;
  const hasNext = page + 1 < maxPages;

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  // for selected geofences
  const handleCheckboxChange = (geofenceId) => {
    if (selectedGeofences.includes(geofenceId)) {
      setSelectedGeofences(selectedGeofences.filter((id) => id !== geofenceId));
    } else {
      setSelectedGeofences([...selectedGeofences, geofenceId]);
    }
  };

  const handleFriendCheckboxChange = (friendId) => {
    if (selectedFriends.includes(friendId)) {
      setSelectedFriends(selectedFriends.filter((id) => id !== friendId));
    } else {
      setSelectedFriends([...selectedFriends, friendId]);
    }
  };

  const handleGroupCheckboxChange = (groupId) => {
    if (selectedGroups.includes(groupId)) {
      setSelectedGroups(selectedGroups.filter((id) => id !== groupId));
    } else {
      setSelectedGroups([...selectedGroups, groupId]);
    }
  };

  const handleBusinessGroupCheckboxChange = (groupId) => {
    if (selectedBusinessGroups.includes(groupId)) {
      setSelectedBusinessGroups(selectedBusinessGroups.filter((id) => id !== groupId));
    } else {
      setSelectedBusinessGroups([...selectedBusinessGroups, groupId]);
    }
  };

  // Extract all member IDs from a list of selected group ids, given the group data set
  const getMemberIdsFromGroups = (groupIds, groupData) => {
    const memberIds = new Set();
    groupIds.forEach((groupId) => {
      const group = groupData.find((g) => g._id === groupId || g.id === groupId);
      if (group && group.userArray) {
        group.userArray.forEach((userId) => memberIds.add(userId._id));
      }
    });
    return Array.from(memberIds);
  };

  const mutation = useMutation((data) => broadcastALert(data), {
    onSuccess: async () => {
      setIsSuccessAndFailBroadcast(true);
      setIsSuccess(true);
      setIsError(false);
      setSelectedGeofences([]);
      setTitle('');
      setSelectedFile(null);
      setMessage('');
      setSelectedFileType(allowedFileTypes[0].value);
      setAlertType('BROADCAST');
      setFileName('');
    },
    onError: (error) => {
      setIsSuccessAndFailBroadcast(true);
      setIsError(true);
      setIsSuccess(false);
    },
  });

  const notifyMutation = useMutation((data) => notifyFriends(data), {
    onSuccess: async () => {
      setIsSuccessAndFailBroadcast(true);
      setIsSuccess(true);
      setIsError(false);
      setSelectedFriends([]);
      setSelectedGroups([]);
      setSelectedBusinessGroups([]);
      setTitle('');
      setSelectedFile(null);
      setMessage('');
      setSelectedFileType(allowedFileTypes[0].value);
      setFileName('');
    },
    onError: (error) => {
      setIsSuccessAndFailBroadcast(true);
      setIsError(true);
      setIsSuccess(false);
    },
  });

  const handleSelectedValue = (value) => {
    setAlertType(value.value);
    // Reset selections when changing type
    setSelectedGeofences([]);
    setSelectedFriends([]);
    setSelectedGroups([]);
    setSelectedBusinessGroups([]);
    setNotifyTab('friends');
  };

  const handleSubmit = () => {
    if (!message) {
      setIsMessageEmpty(true);
      return;
    }

    if (!title && alertType !== 'EMERGENCY') {
      setIsMessageEmpty(true);
      return;
    }

    if (alertType === 'NOTIFY') {
      // Handle NOTIFY type
      let userArray = [];

      if (notifyTab === 'friends') {
        userArray = selectedFriends;
      } else if (notifyTab === 'groups') {
        userArray = getMemberIdsFromGroups(selectedGroups, groupListData);
      } else {
        userArray = getMemberIdsFromGroups(selectedBusinessGroups, businessGroupListData);
      }

      if (userArray.length === 0) {
        alert('Please select at least one friend or group to notify.');
        return;
      }

      const data = {
        date: moment
          .utc()
          .subtract(1, 'day')
          .set({ hour: 18, minute: 30, second: 0, millisecond: 0 })
          .toISOString(),
        title: title,
        message: message,
        userArray: userArray,
        ...(selectedFile && { contentType: selectedFileType }),
        ...(selectedFile && { base64String: selectedFile }),
      };

      notifyMutation.mutate(data);
    } else {
      // Handle BROADCAST and EMERGENCY types
      if (selectedGeofences.length === 0) {
        alert('Please select the geofences for which you want to send the alert.');
        return;
      }

      let data;
      if (alertType === 'BROADCAST') {
        data = {
          date: moment
            .utc()
            .subtract(1, 'day')
            .set({ hour: 18, minute: 30, second: 0, millisecond: 0 })
            .toISOString(),
          geofences: selectedGeofences,
          title: title,
          message: message,
          type: alertType,
          ...(selectedFile && { contentType: selectedFileType }),
          ...(selectedFile && { base64String: selectedFile }),
        };
      } else {
        data = {
          date: moment
            .utc()
            .subtract(1, 'day')
            .set({ hour: 18, minute: 30, second: 0, millisecond: 0 })
            .toISOString(),
          geofences: selectedGeofences,
          title: 'EMERGENCY BROADCAST',
          message: message,
          type: alertType,
        };
      }

      mutation.mutate(data);
    }
  };

  return (
    <StyledContainer>
      <BroadcastHeaderContainer>
        <HeaderTitle>
          <PodcastsIcon style={{ width: '20px', height: '20px' }} />
          <IntlMessages id="nav.broadcast" />
        </HeaderTitle>
      </BroadcastHeaderContainer>
      <BroadcastContainer>
        <BroadcastContainerLeft>
          <>
            <InputWrapper>
              <LabelTitle color={alertType === 'EMERGENCY' ? 'error' : 'normal'}>
                Select the Notification type
              </LabelTitle>
              <DropDown
                options={[
                  { label: 'BROADCAST', value: 'BROADCAST' },
                  { label: 'EMERGENCY', value: 'EMERGENCY' },
                  { label: 'NOTIFY', value: 'NOTIFY' },
                ]}
                selectedOption={handleSelectedValue}
                defaultValue={alertType}
                isRed={alertType === 'EMERGENCY'}
              />
            </InputWrapper>

            {alertType !== 'EMERGENCY' && (
              <>
                <InputWrapper>
                  <LabelTitle>Select File Type</LabelTitle>
                  <DropDown
                    options={allowedFileTypes}
                    selectedOption={(value) => setSelectedFileType(value.value)}
                    defaultValue={selectedFileType}
                  />
                </InputWrapper>

                <InputWrapper>
                  <LabelTitle>
                    Upload file{' '}
                    <span style={{ fontSize: '12px', color: '#777' }}>
                      (Allowed: .pdf, .jpeg, .jpg, .png, .gif) (MaxSize:5mb)
                    </span>
                  </LabelTitle>
                  <FileUploader
                    handleFileChange={handleFileChange}
                    acceptedTypes={getAllowedFileExtensions(selectedFileType)}
                    fileName={fileName}
                  />
                  {error && <Label color="error">{error}</Label>}
                </InputWrapper>

                <InputWrapper>
                  <LabelTitle color={alertType === 'EMERGENCY' ? 'error' : 'normal'}>
                    {alertType === 'NOTIFY' ? 'Notification Title' : 'Notification Title'}
                  </LabelTitle>
                  <InputField
                    placeholderText={
                      isMessageEmpty
                        ? 'This field is required.'
                        : alertType === 'NOTIFY'
                        ? 'Notification Title'
                        : 'Notification Title'
                    }
                    onChange={(e) => setTitle(e.target.value)}
                    color={
                      alertType === 'EMERGENCY' ? 'error' : isMessageEmpty ? 'error' : 'primary'
                    }
                    isPlaceHolder={true}
                    value={title}
                  />
                </InputWrapper>
              </>
            )}

            <InputWrapper>
              <LabelTitle color={alertType === 'EMERGENCY' ? 'error' : 'normal'}>
                Alert message
              </LabelTitle>
              <TextAreaField
                fullWidth
                placeholder={
                  isMessageEmpty ? 'This field is required.' : 'Write your message here...'
                }
                value={message}
                onChange={(e) => handleChange(e)}
                color={alertType === 'EMERGENCY' ? 'error' : isMessageEmpty ? 'error' : 'primary'}
              />
            </InputWrapper>
            <ModalButtonWrapper style={{ justifySelf: 'flex-start' }}>
              <Button
                varient="normal"
                onClick={handleSubmit}
                disabled={notifyMutation?.isLoading || mutation?.isLoading}
              >
                {notifyMutation?.isLoading ? (
                  'Notifying...'
                ) : mutation?.isLoading ? (
                  'Notifying...'
                ) : (
                  <IntlMessages id="nav.broadcast" />
                )}
              </Button>
            </ModalButtonWrapper>
          </>
        </BroadcastContainerLeft>
        <BroadcastContainerRight>
          {alertType === 'NOTIFY' ? (
            <>
              <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                <TabButton
                  buttonArray={[
                    { buttonText: 'friends', textId: '1', icon: <GroupIcon /> },
                    { buttonText: 'groups', textId: '2', icon: <GroupsIcon /> },
                    { buttonText: 'business groups', textId: '3', icon: <GroupsIcon /> },
                  ]}
                  onButtonClick={(selectTab) => setNotifyTab(selectTab)}
                  selectedTab={notifyTab}
                />
              </div>

              {notifyTab === 'friends' ? (
                friendsQuery?.isLoading ? (
                  <Label>Loading friends...</Label>
                ) : (
                  <InputWrapper>
                    <LabelTitle>Select friends to notify</LabelTitle>
                    <ModalGap style={{ paddingBottom: '20px' }}>
                      {friends.length === 0 ? (
                        <Label>No friends found.</Label>
                      ) : (
                        friends.map((friend) => (
                          <CheckBoxContainer key={friend.userId._id || friend.userId.id}>
                            <CheckBoxField
                              name={`friend-${friend.userId._id || friend.userId.id}`}
                              checked={selectedFriends.includes(
                                friend.userId._id || friend.userId.id
                              )}
                              onClick={() =>
                                handleFriendCheckboxChange(friend.userId._id || friend.userId.id)
                              }
                            />
                            <Label>
                              {`${friend?.userId?.firstName} ${friend?.userId?.lastName}`}
                            </Label>
                          </CheckBoxContainer>
                        ))
                      )}
                    </ModalGap>
                  </InputWrapper>
                )
              ) : notifyTab === 'groups' ? (
                groupsQuery?.isLoading ? (
                  <Label>Loading groups...</Label>
                ) : (
                  <InputWrapper>
                    <LabelTitle>Select groups to notify</LabelTitle>
                    <ModalGap style={{ paddingBottom: '20px' }}>
                      {groupListData.length === 0 ? (
                        <Label>No groups found.</Label>
                      ) : (
                        groupListData.map((group) => {
                          const groupId = group._id || group.id;
                          const isExpanded = expandedGroup === groupId;

                          return (
                            <GroupRow key={groupId}>
                              <CheckBoxContainer>
                                <GroupHeaderRow>
                                  <CheckBoxField
                                    name={`group-${groupId}`}
                                    checked={selectedGroups.includes(groupId)}
                                    onClick={() => handleGroupCheckboxChange(groupId)}
                                  />
                                  <Label>
                                    {group?.name || 'Unknown Group'}
                                    {group?.userArray && ` (${group.userArray.length} members)`}
                                  </Label>
                                  <ViewIconButton
                                    isActive={isExpanded}
                                    onClick={() => setExpandedGroup(isExpanded ? null : groupId)}
                                    title={isExpanded ? 'Hide members' : 'View members'}
                                  >
                                    <EyeIcon style={{ width: '20px', height: '20px' }} />
                                  </ViewIconButton>
                                </GroupHeaderRow>
                              </CheckBoxContainer>

                              {isExpanded && (
                                <GroupMemberPanel>
                                  {group.userArray?.length > 0 ? (
                                    group.userArray.map((user, index) => (
                                      <MemberRow key={user._id || user.id} index={index}>
                                        <MemberAvatar>
                                          {user.firstName?.charAt(0) || '?'}
                                        </MemberAvatar>
                                        <MemberInfo>
                                          <Label style={{ margin: 0 }}>
                                            {`${user.firstName} ${user.lastName}`}
                                          </Label>
                                          <MemberEmail>{user.email}</MemberEmail>
                                        </MemberInfo>
                                      </MemberRow>
                                    ))
                                  ) : (
                                    <Label>No members in this group.</Label>
                                  )}
                                </GroupMemberPanel>
                              )}
                            </GroupRow>
                          );
                        })
                      )}
                    </ModalGap>
                  </InputWrapper>
                )
              ) : businessGroupsQuery?.isLoading ? (
                <Label>Loading business groups...</Label>
              ) : (
                <InputWrapper>
                  <LabelTitle>Select business groups to notify</LabelTitle>
                  <ModalGap style={{ paddingBottom: '20px' }}>
                    {businessGroupListData.length === 0 ? (
                      <Label>No business groups found.</Label>
                    ) : (
                      businessGroupListData.map((group) => {
                        const groupId = group._id || group.id;
                        const isExpanded = expandedBusinessGroup === groupId;

                        return (
                          <GroupRow key={groupId}>
                            <CheckBoxContainer>
                              <GroupHeaderRow>
                                <CheckBoxField
                                  name={`business-group-${groupId}`}
                                  checked={selectedBusinessGroups.includes(groupId)}
                                  onClick={() => handleBusinessGroupCheckboxChange(groupId)}
                                />
                                <Label>
                                  {group?.name || 'Unknown Group'}
                                  {group?.userArray && ` (${group.userArray.length} members)`}
                                </Label>
                                <ViewIconButton
                                  isActive={isExpanded}
                                  onClick={() =>
                                    setExpandedBusinessGroup(isExpanded ? null : groupId)
                                  }
                                  title={isExpanded ? 'Hide members' : 'View members'}
                                >
                                  <EyeIcon style={{ width: '20px', height: '20px' }} />
                                </ViewIconButton>
                              </GroupHeaderRow>
                            </CheckBoxContainer>

                            {isExpanded && (
                              <GroupMemberPanel>
                                {group.userArray?.length > 0 ? (
                                  group.userArray.map((user, index) => (
                                    <MemberRow key={user._id || user.id} index={index}>
                                      <MemberAvatar>
                                        {user.firstName?.charAt(0) || '?'}
                                      </MemberAvatar>
                                      <MemberInfo>
                                        <Label style={{ margin: 0 }}>
                                          {`${user.firstName} ${user.lastName}`}
                                        </Label>
                                        <MemberEmail>{user.email}</MemberEmail>
                                      </MemberInfo>
                                    </MemberRow>
                                  ))
                                ) : (
                                  <Label>No members in this group.</Label>
                                )}
                              </GroupMemberPanel>
                            )}
                          </GroupRow>
                        );
                      })
                    )}
                  </ModalGap>
                </InputWrapper>
              )}
            </>
          ) : geofenceQuery?.isLoading ? (
            <Label>Loading...</Label>
          ) : (
            <InputWrapper>
              <LabelTitle color={alertType === 'EMERGENCY' ? 'error' : 'normal'}>
                Please select the geofences for which you want to send the alert
              </LabelTitle>
              <ModalGap style={{ paddingBottom: '20px' }}>
                {geofencesData.map((geofence) => (
                  <CheckBoxContainer key={geofence._id}>
                    <CheckBoxField
                      name={`geofence-${geofence._id}`}
                      checked={selectedGeofences.includes(geofence._id)}
                      onClick={() => handleCheckboxChange(geofence._id)}
                      isRed={alertType === 'EMERGENCY'}
                    />
                    <Label color={alertType === 'EMERGENCY' ? 'error' : 'normal'}>
                      {geofence?.name}
                    </Label>
                  </CheckBoxContainer>
                ))}
              </ModalGap>{' '}
              <div style={{ display: 'grid', gridAutoFlow: 'column', gap: '20px' }}>
                <PaginationLeft
                  onClick={hasPrev ? handlePreviousPage : null}
                  style={{
                    maxWidth: 'fit-content',
                  }}
                >
                  {hasPrev ? (
                    <img
                      src={RightArrowPrimary}
                      alt="RightArrowPrimary.svg"
                      style={{ transform: 'rotate(180deg)', width: '11px', height: '11px' }}
                    />
                  ) : (
                    <img
                      src={RightArrowDisabled}
                      alt="RightArrowPrimary.svg"
                      style={{ transform: 'rotate(180deg)', width: '11px', height: '11px' }}
                    />
                  )}
                  <PaginationButton color="lightGreen" cursor="pointer" disabled={!hasPrev}>
                    <IntlMessages id="nav.drop.down.previous" />
                  </PaginationButton>
                </PaginationLeft>{' '}
                <PaginationTitle>
                  <IntlMessages id="table.pagination.page" defaultMessage="Page" />: {start}-{end}{' '}
                  <IntlMessages id="nav.of" defaultMessage="of" /> {total}
                </PaginationTitle>
                <PaginationRight
                  onClick={hasNext ? handleNextPage : null}
                  style={{
                    maxWidth: 'fit-content',
                  }}
                >
                  <PaginationButton color="lightGreen" cursor="pointer" disabled={!hasNext}>
                    <IntlMessages id="nav.drop.down.next" />
                  </PaginationButton>
                  {hasNext ? (
                    <img
                      src={RightArrowPrimary}
                      alt="RightArrowPrimary.svg"
                      style={{ width: '11px', height: '11px' }}
                    />
                  ) : (
                    <img
                      src={RightArrowDisabled}
                      alt="RightArrowPrimary.svg"
                      style={{ width: '11px', height: '11px' }}
                    />
                  )}
                </PaginationRight>
              </div>
            </InputWrapper>
          )}
        </BroadcastContainerRight>
      </BroadcastContainer>{' '}
      {isSuccessAndFailBroadcast && (
        <BroadCastInfoModal
          onClose={() => setIsSuccessAndFailBroadcast(false)}
          isSuccess={isSuccess}
          isError={isError}
        />
      )}
    </StyledContainer>
  );
};

export default PartnerBroadcast;
